__webpack_require__.p = "/perspectives/";